export default "__VITE_ASSET__DQLJy7JT__"